import React from "react";
import { object } from "prop-types";

const propTypes = { data: object };

const ShareBarMount = (props) => {
  return (
    <div
      data-model={JSON.stringify(props)}
      className="js-share-bar-mount"
    ></div>
  );
};

ShareBarMount.propTypes = propTypes;
export default ShareBarMount;
